import { Component, EventEmitter, Output } from '@angular/core'
import { LinkModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-header-layout',
  templateUrl: './header-layout.component.html',
  styleUrls: ['./header-layout.component.scss']
})
export class HeaderLayoutComponent {
  constructor() {}
}
